import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  border-radius: ', 'px;\n  box-shadow: ', ';\n  box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */\n  color: ', ';\n  max-height: ', 'px;\n  max-width: ', 'px;\n  padding: ', 'px ', 'px;\n  z-index: 200;\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  background: ', ';\n  border-radius: ', 'px;\n  box-shadow: ', ';\n  box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */\n  color: ', ';\n  max-height: ', 'px;\n  max-width: ', 'px;\n  padding: ', 'px ', 'px;\n  z-index: 200;\n\n  &:focus {\n    outline: none;\n  }\n']);

import styled from 'styled-components';
import { borderRadius, colors, gridSize, math, themed } from '@atlaskit/theme';

var backgroundColor = themed({
  light: colors.N0,
  dark: colors.DN50
});
var borderColor = themed({
  light: colors.N60A,
  dark: colors.DN60A
});
var shadowColor = themed({
  light: colors.N50A,
  dark: colors.DN50A
});

var getBoxShadow = function getBoxShadow(props) {
  var border = '0 0 1px ' + borderColor(props);
  var shadow = '0 4px 8px -2px ' + shadowColor(props);

  return [border, shadow].join(',');
};

// eslint-disable-next-line import/prefer-default-export
export var Container = styled.div(_templateObject, backgroundColor, borderRadius, getBoxShadow, colors.text, math.multiply(gridSize, 56), math.multiply(gridSize, 56), math.multiply(gridSize, 2), math.multiply(gridSize, 3));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/inline-dialog/dist/esm/InlineDialog/styled.js
// module id = 452
// module chunks = 0